module.exports = __webpack_public_path__ + "static/media/download pic.ca71620e.png";